export default __webpack_public_path__ + "static/media/Paid Advertising_icon.3f1488ab.gif";